import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-teal-50 via-white to-emerald-50 py-16">
      <div className="max-w-4xl mx-auto px-4">
        <div className="flex items-center gap-2 mb-6 justify-center">
          <div className="px-4 py-1 bg-teal-500 text-white text-sm font-bold rounded-full whitespace-nowrap">
            2026年最新版
          </div>
          <div className="px-4 py-1 bg-orange-500 text-white text-sm font-bold rounded-full whitespace-nowrap">
            永年無料
          </div>
        </div>
        
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 text-center mb-6 leading-tight">
          年会費無料でおすすめの<br />クレジットカードランキング
        </h1>
        
        <p className="text-lg text-gray-700 text-center leading-relaxed mb-8">
          維持コスト0円で持てる高還元率カードを厳選。<br />
          永年無料で使い続けられるお得なクレジットカードを徹底比較しました。
        </p>
        
        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-gray-600 mb-12">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-500 text-xl"></i>
            <span>永年無料</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-500 text-xl"></i>
            <span>高還元率</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-teal-500 text-xl"></i>
            <span>維持費0円</span>
          </div>
        </div>

        {/* 1️⃣ ファーストビュー即決ブロック */}
        <div className="bg-gradient-to-r from-teal-500 to-emerald-500 rounded-2xl p-8 text-white shadow-xl">
          <div className="flex items-center gap-2 mb-4">
            <div className="px-3 py-1 bg-white text-teal-600 text-xs font-bold rounded-full whitespace-nowrap">
              迷ったらコレ！
            </div>
            <div className="px-3 py-1 bg-yellow-400 text-gray-900 text-xs font-bold rounded-full whitespace-nowrap">
              No.1おすすめ
            </div>
          </div>
          
          <h2 className="text-2xl font-bold mb-4">三井住友カード（NL）</h2>
          
          <div className="grid grid-cols-3 gap-4 mb-6">
            <div>
              <div className="text-sm opacity-90 mb-1">年会費</div>
              <div className="text-xl font-bold">永年無料</div>
            </div>
            <div>
              <div className="text-sm opacity-90 mb-1">還元率</div>
              <div className="text-xl font-bold">最大7%</div>
            </div>
            <div>
              <div className="text-sm opacity-90 mb-1">発行</div>
              <div className="text-xl font-bold">最短10秒</div>
            </div>
          </div>
          
          <ul className="space-y-2 mb-6">
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-xl mt-0.5"></i>
              <span>対象のコンビニ・飲食店で最大7%還元</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-xl mt-0.5"></i>
              <span>年会費永年無料で維持コスト0円</span>
            </li>
            <li className="flex items-start gap-2">
              <i className="ri-check-line text-xl mt-0.5"></i>
              <span>最短10秒でカード番号発行</span>
            </li>
          </ul>
          
          <div className="flex flex-col sm:flex-row gap-3">
            <Link 
              to="/mitsui"
              className="flex-1 px-6 py-4 bg-white text-teal-600 text-center rounded-lg hover:bg-gray-50 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
            >
              詳細ページを見る
            </Link>
            <a 
              href="#apply"
              className="flex-1 px-6 py-4 bg-yellow-400 text-gray-900 text-center rounded-lg hover:bg-yellow-300 transition-colors font-bold text-lg whitespace-nowrap cursor-pointer"
            >
              公式サイトはこちら
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
